import '../static/ScreenReaderContent.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
const screenReaderContent = `_screenReaderContent_7ab41ab`;
const styles = { screenReaderContent };
const ScreenReaderContent = forwardRef(
  ({
    as = "span",
    className,
    ...props
  }, ref) => {
    const Component = useTagName(as);
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ...props,
        ref,
        className: clsx(styles.screenReaderContent, className)
      }
    );
  }
);
export {
  ScreenReaderContent as S
};
//# sourceMappingURL=ScreenReaderContent.CmT4o4X9.mjs.map
